import React from "react";
import { BackTop } from "antd";
import "./TermsOfService.css";

class TermsOfService extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="constrain">
        <div className="terms-container">
          <div className="terms-header">
            <h1>TERMS OF SERVICE</h1>
            <p className="last-updated">Last Updated: December 2025</p>
          </div>

          <div className="terms-content">
            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>Table of Contents</h2>
              <ol>
                <li><a href="#section-1">Terms of Service</a></li>
                <li><a href="#section-2">Eligibility</a></li>
                <li><a href="#section-3">Indemnification</a></li>
                <li><a href="#section-4">Disputes</a></li>
                <li><a href="#section-5">Account Creation</a></li>
                <li><a href="#section-6">Content</a></li>
                <li><a href="#section-7">Copyright Infringement</a></li>
                <li><a href="#section-8">Permissions</a></li>
                <li><a href="#section-9">Use of Service</a></li>
                <li><a href="#section-10">Modifications</a></li>
                <li><a href="#section-11">Restrictions</a></li>
                <li><a href="#section-12">Geographical Restrictions</a></li>
                <li><a href="#section-13">Third-Party Content & Links</a></li>
                <li><a href="#section-14">Third-Party Access</a></li>
                <li><a href="#section-15">Third-Party Providers</a></li>
                <li><a href="#section-16">Advertisements</a></li>
                <li><a href="#section-17">Miscellaneous Fees</a></li>
                <li><a href="#section-18">Promotions</a></li>
                <li><a href="#section-19">Products and Services</a></li>
                <li><a href="#section-20">Warranties and Disclaimers</a></li>
                <li><a href="#section-21">Limitation of Liability</a></li>
                <li><a href="#section-22">Class-Action Waiver</a></li>
                <li><a href="#section-23">Informal Dispute Resolution</a></li>
                <li><a href="#section-24">Arbitration Agreement</a></li>
                <li><a href="#section-25">Termination of Access</a></li>
                <li><a href="#section-26">Notices and Changes to Terms and Services</a></li>
                <li><a href="#section-27">Governing Law and Forum Choice</a></li>
                <li><a href="#section-28">California Residents</a></li>
                <li><a href="#section-29">Survivability</a></li>
                <li><a href="#section-30">Miscellaneous</a></li>
                <li><a href="#section-31">Entire Agreement</a></li>
                <li><a href="#section-32">Assignment</a></li>
                <li><a href="#section-33">Severability</a></li>
                <li><a href="#section-34">Contact Information</a></li>
              </ol>
            </div>

            {/* Section 1 */}
            <section id="section-1" className="terms-section">
              <h2>1. Terms of Service</h2>
              <p>
                The Terms of Service, ("Terms"), apply to your access to the site, www.nocapvote.com, ("Site"), 
                and the Privacy Policy, and Community Guidelines, incorporated herein, No Cap Vote's mobile 
                application(s), website(s), software, applications, and other downloads, ("Apps"), made available 
                to you by No Cap Vote, LLC, owner and operator, ("No Cap Vote," "our," "us," or "we"), our 
                affiliates, subsidiary(ies), partner(s), and/or associates.
              </p>
              <p>
                The Terms define your access to the Site in addition to our Services, which may include verification 
                and authentication of your identity, requests and communications with us, including, but not limited 
                to, maintaining registrations, subscriptions, functionalities, features, or our third-party service 
                providers, social networking application(s), now known, or to be formed, without limitation, that we 
                offer, ("Services"), for public, personal, educational, or entertainment use.
              </p>
              <p>
                Please read these Terms, including the <a href="/privacypolicy">Privacy Policy</a>, and{" "}
                <a href="/communityguidelines">Community Guidelines</a>, ("Our Policies"), incorporated herein by 
                reference, carefully before you access or use the Site or Services. By proceeding to access or use 
                the Site or Services, subject to local, state, national, or other applicable laws, rules, and 
                regulations, ("Applicable Laws"), you will be deemed to have acknowledged, accepted, agreed to be 
                legally bound by our Terms and policies.
              </p>
              <p>
                The Terms outlined below constitute a legally binding agreement made between us and you and/or any 
                company or other legal entity that you represent and warrant you have all the legal rights, power, 
                permissions, capacity, releases, consents, licenses, and authorization to act on behalf of, bind, 
                and represent such company or entity, ("User," "you," "your," "yourself") to these Terms.
              </p>
            </section>

            {/* Section 2 */}
            <section id="section-2" className="terms-section">
              <h2>2. Eligibility</h2>
              <p>
                Subject to Applicable Laws, you must be legally permitted to access the Site or use the Services 
                based on your country's laws. If you are at least 13 years of age, or subject to the age of majority 
                of your country, your parent or legal guardian must read these Terms on your behalf. If you are a 
                parent or legal guardian of a User under the age of 18, authorizing your minor to access any part of 
                the Services constitutes your understanding and acceptance of the Terms described herein, and you are 
                solely responsible for your minor's access or use of the Site or Services.
              </p>
              <p>Additionally, subject to Applicable Laws, you are restricted from accessing, using, or engaging in 
              any component of our Services if you:</p>
              <ul>
                <li>are on a denied, prohibited, or restricted party list;</li>
                <li>are not complying with the U.S. export control and economic requirements;</li>
                <li>are designated by the U.S. government as a terrorist-supporting country;</li>
                <li>are a convicted sex offender; or</li>
                <li>held an account that was disabled for violating any of Terms and/or policies.</li>
              </ul>
            </section>

            {/* Section 3 */}
            <section id="section-3" className="terms-section">
              <h2>3. Indemnification</h2>
              <p>
                Except to the extent prohibited by law, you agree to indemnify, defend, and hold harmless us, and 
                each of our affiliates, subsidiary(ies), partner(s), associates, or related entities, or their 
                respective officers, directors, shareholders, members, employees, representatives, agents, contractors, 
                third-party service providers, vendors, suppliers, or licensors, individually and collectively, as 
                applicable, ("No Cap Vote Parties"), from and against any and all disputes, damages, losses, 
                liabilities, costs, expenses, demands, including, but not limited to, accounting fees, attorneys' fees, 
                litigation costs and expenses, made by any third party, directly or indirectly, due to, arising out of, 
                or related to:
              </p>
              <ul>
                <li>your access, use, or misuse, in whole or in part, of the Services;</li>
                <li>your breach or violation of the Terms or our policies;</li>
                <li>your User Content or App that you Submit or Transmit;</li>
                <li>your products, services, actions, or inactions;</li>
                <li>your violation of any third-party right, including, but not limited to, copyright, trademark, 
                trade secret, patent, publicity, property, or privacy right;</li>
                <li>your violation of Applicable Laws, codes, statutes, ordinances, or any orders from any entity(ies) 
                (administrative or legislative);</li>
                <li>your breach, falsification, or misrepresentation of information relating to Your Account or any 
                user of Your Account;</li>
                <li>your breach or anticipatory breach of any Terms, agreements, representations, warranties, and 
                covenants; or</li>
                <li>any user content or information posted, submitted, or transmitted, through Your Account or 
                device(s), such as computer, tablet, mobile, ("Devices"), that violates of any third-party right, 
                including, but not limited to, infringement on copyright, trademark, trade secret, trade dress, patent, 
                publicity, property, privacy, or other rights of any person or entity or defames any person or entity.</li>
              </ul>
              <p>
                No Cap Vote and/or No Cap Vote Parties will make their best efforts to provide the Site or Services 
                with reasonable skill and attention. You agree to immediately contact No Cap Vote of any third party 
                claim(s), cause(s) of action, or demand(s). Solely at your expense, we reserve the right to assume 
                exclusive control and defense of any matter, which you are entitled to indemnify No Cap Vote and/or 
                No Cap Vote Parties, and you agree to fully cooperate with our defense of these claims. We will use 
                reasonable efforts to notify you of any such claim(s), cause(s) of action, or demand(s). No Cap Vote 
                and/or No Cap Vote Parties reserve all rights not expressly granted in, and to, its respective Site(s), 
                Services, content, copyright, trademarks, trade secrets, and the like. We reserve all rights not 
                expressly granted to you and reserve all rights and remedies against any users who breach the Terms.
              </p>
              <p>
                This defense and indemnification obligation will survive the Terms and your use of the Services. If 
                you do not agree to be bound by these Terms or our policies, you may not access nor use the Site or 
                Services.
              </p>
            </section>

            {/* Section 4 */}
            <section id="section-4" className="terms-section">
              <h2>4. Disputes</h2>
              <p>
                You agree to defend, indemnify, and hold harmless No Cap Vote and/or No Cap Vote Parties from and 
                against all demands, claims, cause of action, disputes, damages, controversy, obligations, losses, 
                liabilities, judgments, suits, or proceedings, expenses (including, but not limited to, litigation 
                costs and expenses, accounting, and attorneys' fees), whether based in contract, regulation, tort, or 
                any other legal or equitable theory, ("Disputes"). Moreover, you unconditionally agree and consent that 
                any claim(s), dispute(s), or controversy(ies) must only be resolved by binding and final arbitration on 
                an individual basis; and you may not bring any claim(s) as a plaintiff, representative action, class 
                proceeding, nor as a class member, collective, or consolidation, limiting the remedies available in the 
                event of a dispute. In addition, you waive any and/or all your rights to pursue Disputes or participate 
                in any court or jury trial, class-action lawsuit, class-wide arbitration, collective action, private 
                attorney actions, and consolidation with other arbitrations against us to seek relief.
              </p>
              <p>
                By proceeding to access or use the Site or Services, we may provide, transmit, post, email, text 
                message or SMS, MMS, push notification, postal mail, or notify you with known, or to be formed, 
                disclosures, notices, announcements, transaction information, or other communications that you deem to 
                have received, which satisfies any legal requirements.
              </p>
            </section>

            {/* Section 5 */}
            <section id="section-5" className="terms-section">
              <h2>5. Account Creation</h2>
              <p>
                The Site or Services may contain communication features that permit you to publicly interact, 
                communicate, submit, or transmit information, content, or other materials with other visitors or users. 
                Upon downloading our application(s), creating an account, and registering your information, ("Your 
                Account"), and/or using our Services, you are solely responsible for:
              </p>
              <ul>
                <li>maintaining and providing accurate, complete, truthful, and current information in Your Account;</li>
                <li>maintaining and updating your username(s) you create or select to use for public display, 
                individual/company name(s); password(s), signature, address(es), telephone number(s), email address(es), 
                date of birth, display language, professional affiliates, professional experience, setting preferences, 
                interests, or any other information and login credentials or data;</li>
                <li>for maintaining the confidentiality of, securing, deactivating, deleting, or restricting third-party 
                access to Your Account, the password, and all activities that take place;</li>
                <li>any and/or all information you communicate, submit, or transmit through the Services; and</li>
                <li>notifying us immediately if you determine any unauthorized access or security breach to Your Account 
                without your permission at notice@nocapvote.com. We reserve the right to take further steps to verify 
                the information provided by you. If you forget, or cannot validate, your password or Your Account 
                information, you acknowledge, accept, and agree that Your Account may not be accessible to you.</li>
              </ul>
            </section>

            {/* Section 6 */}
            <section id="section-6" className="terms-section">
              <h2>6. Content</h2>
              <p>Subject to your compliance with the Terms and Applicable Laws, regarding the Services:</p>
              <ul>
                <li>shared and accessible websites, content, texts, Direct Messages, posts, reviews, messages, articles, 
                images, illustrations, graphics, designs, photographs, products, services, sounds or voice interactive 
                services, music, any pre-recorded/recorded audio/visual content, embedded video(s), streams, live-streaming 
                distribution, AI content, interactive features, promotions, subscriptions, including software, source/object 
                code(s), application(s), data, third-party links affiliated to us, interfaces, tools, materials or 
                otherwise, brands, logos, copyrights, service marks, trademarks, trade secrets, patents, intellectual 
                property rights, ("Our Content"), are retained and the property of, are owned, operated, and/or licensed 
                by No Cap Vote, its affiliates, subsidiary(ies), partner(s), and/or third-party licensors, which are 
                protected by proprietary and intellectual property rights and laws. Unless you possess our expressed 
                written permission, No Cap Vote's logo, products, service name, and/or trademarks, in whole or in part, 
                may not be used;</li>
                <li>at your own risk, you are solely responsible for any and/or all user-generated information, activity, 
                or transactions that you publicly generate, communicate, share, post, repost, text, upload, provide, 
                create, comment, submit, transmit, confirm, disclose, publish, download, message, email, review, store, 
                tag, produce, promote, broadcast, syndicate, distribute, or participate in, such as the public online 
                forums, message boards, chats, blogs, or other forms of transmissions, ("Submit or Transmit"), including, 
                but not limited to, user-generated content, articles images, illustrations, graphics, designs, photographs, 
                products, services, music, logo, sounds or voice interactive services, any prerecorded/recorded audio/visual 
                content, embedded video(s), live streaming distribution, AI content, interactive features, promotions, 
                subscriptions, which may include software, source code(s), application(s), data, third-party links 
                unaffiliated to us, interfaces, tools, or other materials, including brands, logos, copyrights, service 
                marks, trademarks, patents, or any intellectual property, ("User Content"). In connection with the Terms 
                or your access or use of the Site or Services, notwithstanding anything to the contrary, in no event shall 
                No Cap Vote, nor No Cap Vote Parties, be liable nor responsible for any User Content or Dispute arising 
                from you partaking in the Services;</li>
                <li>you own any and/or all User Content that you Submit or Transmit, and you waive any rights to privacy, 
                publicity, including, but not limited to, approval or inspection of marketing or promotional materials; or</li>
                <li>you acknowledge, accept, and agree that you do not own, nor have any rights, to other content of other 
                users nor Our Content.</li>
              </ul>
              <p>
                We are under no guarantees nor obligations to take reasonable measures to monitor, scan, or inspect any 
                content, User Content, including, but not limited to, or usage for violations of unauthorized access, use, 
                distribution, or third-party rights.
              </p>
              <p>
                We do not claim any ownership, proprietary, or intellectual property rights to User Content that you Submit 
                or Transmit. At your own risk and responsibility, any User Content, data, information, materials, or ideas 
                that you Submit or Transmit on our Services will be deemed your acknowledgement, acceptance, and agreement 
                to be treated as nonconfidential and nonproprietary content, which may be disseminated or used by us for 
                any purpose described herein. Any personal data provided on our Services will be in accordance with the 
                Terms and Applicable Laws regarding privacy.
              </p>
            </section>

            {/* Section 7 */}
            <section id="section-7" className="terms-section">
              <h2>7. Copyright Infringement</h2>
              <p>
                You are strictly prohibited from violating any third-party right, including, but not limited to, 
                infringement on copyright, trademark, trade secret, trade dress, patent, publicity, property, privacy, or 
                other rights of any person or entity or defames any person or entity. In accordance with the Digital 
                Millenium Copyright Act of 1998, ("DMCA"), set forth, if you believe that, on our Sites or Services, any 
                material(s) infringed on any copyrights, you must notify us immediately at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a> to process your notice of copyright 
                infringement. Moreover, you may also contact us if you have any questions, concerns, or other notices 
                relating to copyrighted material.
              </p>
              <p>
                All notices must comply with the requirements of DMCA 17 U.S.C. § 512(c)(3). Any email notice of any 
                copyright or other intellectual infringement must be labeled "Notice of Infringement" in the subject field 
                of your email, must include the identification of the copyrighted work alleged to be the subject of 
                infringement, signature of the owner or the person authorized to act on behalf of the owner of the 
                copyright material, contact information, such as email, phone number, a summary description of copyright 
                material, any and/or all substantive materials relating to the ownership of the copyright materials, and 
                your attestation that your statement is under penalty of perjury where you believe the material or content 
                alleged to have been infringed upon was not authorized by the copyright owner, its agent, or the law. 
                Although the nature of this notice may not ensure complete removal from the Internet of the copyright 
                materials that are publicly posted, we may take necessary appropriate action, subject to Applicable Laws. 
                Without sufficient information and proper identifying subject descriptions, in relation to your Notice of 
                Infringement, we are not responsible for notices that are not labeled or properly delivered, and we may not 
                be able to respond to such notice.
              </p>
              <p>
                Upon receipt of such notice, we may make reasonable efforts to investigate, remove and/or disable access to 
                the content or material(s) alleged to be the subject of infringement, including, but not limited to, 
                suspending or terminating the account user who is alleged to have infringed upon another's intellectual 
                property rights.
              </p>
            </section>

            {/* Section 8 */}
            <section id="section-8" className="terms-section">
              <h2>8. Permissions</h2>
              <p>
                We do not claim any ownership, proprietary, or intellectual property rights to User Content that you Submit 
                or Transmit.
              </p>
              <p>
                Subject to your compliance with the Terms and Applicable Laws, you represent and warrant that you have all 
                rights, power, authority, clearance, permissions, to license and/or sublicense, including, but not limited 
                to, intellectual property, publicity, copyright, proprietary, and/or contractual rights, ("Authority"), to 
                granting us, our affiliates, subsidiary(ies), partner(s), associates, licensors, authorized users, and/or 
                No Cap Vote Parties, the nonexclusive, worldwide, royalty-free, fully paid, irrevocable, unrestricted, 
                unlimited, perpetual license, and the full transferable sublicensable license, or other proprietary rights 
                of any and/or all User Content that you Submit or Transmit on the Services or on social networking accounts 
                you link to, now known, contributed, to be formed, without notice, obligations, or restrictions to you, 
                ("The Permissions"), including, but not limited to:
              </p>
              <ul>
                <li>analyze, gather, use, process, copy, modify, reproduce, combine, store, and/or archive any and/or all 
                data, including User Content;</li>
                <li>create, develop, remove, communicate, host, transmit, transfer, import, assign, publish, disclose, post, 
                repost, promote, sell, resell, lend, lease, frame, publicly perform or display, disseminate, reformat, 
                and/or adapt current derivative or creative works or improvements, patentable or not, translations, 
                summaries, re-blogs, reposts, downloaded content, AI training and learning, metadata, or the like, which 
                may be permitted by the features, functionalities, or other use of the Services;</li>
                <li>access, use, share, incorporate, produce, syndicate, broadcast, reproduce, publish, distribute, or 
                redistribute any User Content, in any manner, mode of delivery, form, format, medium, channel, technology, 
                media, or media channels, including your username, your name, identity, company name, franchise name, voice, 
                concept(s) or idea(s), websites, applications, software, technology, including, but not limited to, trade 
                names, trademarks, service marks, logos, and any and/or all images you provide through the Services or 
                outside of our Services; or</li>
                <li>the transfer of, or share of, your Personal Information via servers, third-party servers, vendors, 
                customer service, payment processing, and other related services, or nationally, which may be utilized to 
                provide, improve, enhance, modify, upgrade, maintain, and/or protect the quality or safety of our Services, 
                as well as to develop new services and special offers, including, but not limited to, content, products, 
                functionalities, features, links, and/or tools.</li>
              </ul>
              <p>Further, in relation to the User Content that you Submit or Transmit through the Services and The 
              Permissions, you represent and warrant that:</p>
              <ul>
                <li>you voluntarily waive any and/or all claims, demands, actions, or assignments to us;</li>
                <li>you have all the Authority necessary required to grant us The Permissions to any User Content described 
                herein that you Submit or Transmit;</li>
                <li>you waive, or have no, ownership or right to revenue-sharing, goodwill, credit, compensation, 
                reimbursement, nor property rights, interests, or value whatsoever for: (i) The Permissions of User Content 
                or any other content, comments, or feedback you Submit or Transmit through the Services, and/or (ii) any 
                contents accessed by you, or on social networking accounts you link to, that are transferable to individuals, 
                companies, organizations, or entities to monetize and/or improve the Services;</li>
                <li>you waive all infringement, moral, equivalent, or other personal rights, privacy, data protection, or 
                misappropriation of any proprietary rights or third-party rights against us that you Submit or Transmit; and</li>
                <li>we may terminate The Permissions with any user at any time, at our sole discretion, without notice or 
                obligation to you, for any reason.</li>
              </ul>
              <p>
                By continuing to access or use the Site or Services, you acknowledge and agree that the transfer and process 
                of your Personal Information that you provide is governed under the laws of the State of California.
              </p>
            </section>

            {/* Section 9 */}
            <section id="section-9" className="terms-section">
              <h2>9. Use of Services</h2>
              <p>
                No Cap Vote provides Services for your use to connect, experience, and engage with audiences. Our Site, 
                Services, App(s), and/or Our Content are owned and operated by us. The Site or Services are protected by 
                copyright, trademark, and other laws by the United States copyright laws and treaty provisions. Unless you 
                possess our expressed written permission, you are strictly prohibited from copying or reproducing the items 
                or products downloaded to any other server or location for the purpose of reproducing, distribution, selling, 
                sharing, transferring, assigning, or for any other reason.
              </p>
              <p>
                We allow you permission, with limited restrictions, to access or use the Site or Services. aimed to deliver 
                an engaging environment for personal, professional, educational, or entertainment use, under Your Account. 
                Subject to our Terms and Applicable Laws, at your own risk, regardless of whether you are permitted access 
                or use of the Services through Your Account:
              </p>
              <ul>
                <li>with the exception to service providers, we grant you the limited non-exclusive, nontransferable, 
                nonassignable, non-sublicensable, noncommercial, and revocable right to install, access, or use the Services 
                through the No Cap Vote Apps utilizing app distributors or the No Cap Vote website(s) on electronic Devices 
                you use; you warrant that you have all the Authority required and necessary to grant The Permissions and 
                rights to us of the User Content you disclose, Submit or Transmit;</li>
                <li>you warrant and represent that the electronic Devices you use are owned and controlled by you when 
                accessing or using of Site or Services;</li>
                <li>the Site, Services, and/or any of Our Content is not sold to you, nor do you acquire any ownership 
                interest or rights in the Site, Services, or any of our Our Content;</li>
                <li>unless you possess our expressed written permission, No Cap Vote does not give you any right whatsoever, 
                in whole or in part, to use No Cap Vote's name, service name(s), logo(s), domain name(s), brand features, 
                trademark(s), proprietary rights, and/or other distinguishing features;</li>
                <li>you represent and warrant the User Content you publicly Submit or Transmit is not in violation of any 
                Applicable Laws, restrictions, or third-party rights;</li>
                <li>you represent and warrant your eligibility to engage in any political activity(ies), such as 
                candidate/campaign/ballot/political action committees, or otherwise, ("political activities"), that you are 
                solely responsible for complying with all Applicable Laws required if you are engaging in any political 
                activities, and you will not use or solicit any of our monetization tools to deliver, receive, transact with, 
                or contribute to any political activities, channels, or contribution(s); or</li>
                <li>user-generated live streaming on the Services must meet the accepted set of standards and may not be 
                combined with other third-party services.</li>
              </ul>
              <p>
                As a result of the Terms of Service, you acknowledge, accept, and agree that there is no joint venture, 
                agency, partnership, or employment relationship exists between you and No Cap Vote.
              </p>
              <p>
                Unless you possess our expressed written permission or for informational, noncommercial, or personal use 
                only, provided that all copyright and other proprietary notices are kept intact, where you do not modify, 
                copy, or post the content on any network computer or broadcast in any public media forum, no content or any 
                part from our Site(s), Services, or App(s), or Mark(s) owned, operated, controlled, or licensed by us may 
                be copied, reproduced, republished, modified, aggregated, uploaded, posted, publicly displayed, encoded, 
                translated, transmitted, distributed, sold, licensed, or otherwise exploited in any way, for any commercial 
                purpose whatsoever.
              </p>
            </section>

            {/* Section 10 */}
            <section id="section-10" className="terms-section">
              <h2>10. Modifications</h2>
              <p>
                Subject to our Terms and Applicable Laws, effective immediately upon your access or use of any aspect of the 
                Site or Services, at your own risk, without notice or liability to you or to any third party, permanently or 
                temporarily, we may add, amend, improve, modify, delete, suspend, refuse, discontinue, hide, moderate, or 
                supplement:
              </p>
              <ul>
                <li>the Services, scope of the Services, the Site, Our Content, Terms or our policies, or any information, 
                in whole or in part, including any features, functionalities, quality, type, compatibility, or availability;</li>
                <li>any current or future advertisement(s), targeted ad(s), information, content, or other sponsored materials;</li>
                <li>content, version(s), feature(s), or functionality(ies) that may or may not be available in your location, 
                state, region, or country; or</li>
                <li>Your Account, any User Content, links, other content or materials deemed or determined to be false, 
                ineligible for monetization, including any addition, production, or creation that may be a liability for us, 
                or that violates Terms, our policies, or rights of any third party, now or in the future.</li>
              </ul>
              <p>
                You understand and agree that it is your responsibility to check on any modifications, amendments, or 
                supplements to the Terms; that we will not be liable to you or any third party for any additions, amendments, 
                improvements, modifications, deletions, discontinuances, suspensions, or supplementations of the Site, 
                Services, or any portion thereof.
              </p>
              <p>
                Any provisions in the Terms are for the benefit of No Cap Vote or No Cap Vote Entities where each individual 
                or entity(ies) shall have the right to assert and enforce the provisions directly against you on its own behalf.
              </p>
            </section>

            {/* Section 11 */}
            <section id="section-11" className="terms-section">
              <h2>11. Restrictions</h2>
              <p>
                Restrictions to accessing or using the Site or Services. is intended for United States residents over 13 
                years of age who may not comply with rules, regulations, laws, or legal requirements. Subject to the Terms 
                and Applicable Laws, under Your Account, unless you possess our expressed written permission, except for its 
                intended purpose, you are strictly prohibited from, in any form:
              </p>
              <ul>
                <li>directly or indirectly, in whole or in part, from altering, obscuring, adapting, reproducing, removing, 
                modifying, interfering, altering, posting, downloading, retrieving, copying, collecting, compiling, adapting, 
                decompiling, disassembling, reverse engineering, distributing, transmitting, broadcasting, displaying, 
                translating, or exploiting any of Our Content, Site, Services, products, data, files, documents, derivative 
                works or creative works, other content and materials, including, but not limited to, software, any source 
                codes, HTML/Javascript, methods, techniques, patentable or not, for commercial, business, or for any purpose, 
                such as to host, license, sublicense, transfer, assign, publish, distribute, lease, rent, sell, resell, lend 
                trade, or publicly perform or make available any portion of, use of, or access to Our Content, Services, 
                information, or materials;</li>
                <li>any breach or anticipatory breach of any Terms, agreements, representations, warranties, and covenants;</li>
                <li>engaging, in any way, by yourself or with others, to violate the Terms, Privacy Policy, or Community 
                Guidelines;</li>
                <li>selling, leasing, transferring, sharing, renting, or providing access to Your Account to any third party, 
                for any reason, including, but not limited to, uploading content, selling, purchasing, or soliciting any forms 
                of payment;</li>
                <li>accessing, using, or permitting another user to access other users' account(s), or use our Services, if 
                you do not have the Authority or are not legally competent;</li>
                <li>using our Services to insert your own or a third party's branding, advertising, or promotional content 
                into the Site's or Services' content or materials;</li>
                <li>using our Services to conduct any wrongful acts or illegal purposes, including, but not limited to, unfair 
                trade practices, infringing (or repeatedly infringing) on any copyright, trademark, trade secrets, or 
                intellectual property materials, patents, proprietary rights, privacy, data protection, or moral rights of any 
                user, entity, or other third-party rights. If you believe that a user on the Services is infringing on any of 
                the above-mentioned rights, please contact us at <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>;</li>
                <li>forging digital signatures of, falsely claiming affiliations to, misrepresenting information to, 
                impersonating, tricking, or defrauding, any user(s), person(s), or entity(ies), for any purpose, including, 
                but not limited to, attempting to collect unauthorized Personal Information, unauthorized framing, 
                incorporating the Site or Services into other links, websites, products, services, or programs that we do not 
                endorse or support;</li>
                <li>collecting, extracting, or gathering data or automated programs, email addresses, usernames, phone numbers, 
                contact information, or any other data or private information relating to users, content, or otherwise from 
                the Site or Services for unauthorized commercial, personal, or other purposes or motives to alter, deceive, or 
                falsify information, including, but not limited to, solicit, spam material, petition, sell, resell, promote, 
                advertise, email, or send bulk or junk mail, and other forms of solicitation; or</li>
                <li>you are strictly prohibited, for any reason, from deleting, disabling, removing, disrupting, tampering, 
                testing, interfering with, scanning, or circumventing the functionalities, technical systems, security 
                features, software, or otherwise, of the Services, in whole or in part, by collecting, using, storing, 
                uploading, transmitting, submitting, scraping, forging any TCP/IP framework for any reason, or taking any 
                other actions, including, but not limited to, using viruses, adware, worms, spyware, trojans, bugs, spiders, 
                malicious code, altering identifiers, unauthorized script, or other automated systems, software, or programs 
                which may prevent, delay, restrict, interrupt, destroy, shut down, severely damage, our ability to operate, 
                properly maintain, or access the Site, Services, features, functionalities, contents, and/or use, in whole or 
                in part, to function, resulting in, and directly affecting, connected networks, servers, software applications, 
                security-related features, functionalities, and techniques, and user functionalities.</li>
              </ul>
              <p>
                Submitting or transmitting any wrongful, unlawful, or harmful information, content, or other materials in any 
                part of the Services is prohibited. Submitting or Transmitting to us, or in any part of the Services, or to 
                any person(s), or entity(ies) content, language, reports, or materials that are improper, false, inaccurate, 
                libelous, offensive, misleading, unlawful, infringing, bigoted, discriminatory, defamatory, obscene, 
                inflammatory, threatening, harassing, harmful, threatening, abusive, indecent, pornographic, profane, 
                scandalous, sexually explicit content, or invasive of privacy or publicity rights may give rise to any civil 
                or criminal liability under the law. Please refer to the <a href="/communityguidelines">Community Guidelines</a>.
              </p>
              <p>
                By accessing or using the Site or Services, you may be exposed to other user content or materials that you may 
                find to be offensive, distasteful, or vulgar. Please refer to our{" "}
                <a href="/communityguidelines">Community Guidelines</a>. If you do not agree to be bound by these Terms, you 
                may not access the Site or use these Services.
              </p>
            </section>

            {/* Section 12 */}
            <section id="section-12" className="terms-section">
              <h2>12. Geographical Restrictions</h2>
              <p>
                No Cap Vote nor No Cap Vote Entities make no representations or warranties that any content, information, 
                products, materials or other services contained in the Site or Services are appropriate or available for 
                access, or access from, or adheres to the applicable rules and laws of, geo-located areas, other 
                jurisdictions, or foreign country(ies).
              </p>
              <p>
                The access or use of the Site or Services is intended for United States residents over 13 years of age and 
                may not comply with legal requirements of other country's laws, and regulatory requirements of other countries 
                may differ from the United States. If you use the Services from other jurisdictions or foreign country(ies), 
                you are solely responsible for complying with all applicable local or international laws in relation to using 
                the Services. We reserve the right, at our sole discretion, to limit the accessibility of any portion of a 
                Site or Services to any entity, person, third party, geographic area, or jurisdiction, including, but not 
                limited to content, products, services, information, materials or other features.
              </p>
              <p>
                In accordance with these Terms and Applicable Laws, for United States residents acting as a consumer from the 
                United Kingdom, Switzerland, the European Union, or European Economic Area, or other foreign countries, No Cap 
                Vote may provide reasonable prior notice of any notices or amendments to the use of the Services. We are not 
                responsible for any violations of law, and you may not use or export any materials through the Services in 
                violation of any U.S. export laws and regulations.
              </p>
              <p>
                In compliance with Applicable Laws of the United States, if you do not cancel or delete Your Account, or any 
                part thereof, your continued use of the Services will be deemed your acknowledgement, acceptance, and 
                agreement to the Terms and will be at your own risk and responsibility.
              </p>
            </section>

            {/* Section 13 */}
            <section id="section-13" className="terms-section">
              <h2>13. Third-Party Content & Links</h2>
              <p>
                The Site or Services may contain third-party hyperlinks, links, or pointers for/to other sites that may be 
                provided or maintained by you, other users, or third parties, including third-party content and further links 
                in a third-party site. Accessing or using third-party sites linked from our Site or Services are solely and 
                entirely at your own risk and responsibility.
              </p>
              <p>
                No Cap Vote grants you the revocable permission to link to certain parts of the Services. However, at any 
                time, for any reason, we reserve the right to terminate or prohibit any link(s) to the Site or Services. 
                Unless you possess our expressed written permission, any links to our Site or Services does not represent its 
                relationship or affiliation with us, does not imply our endorsement, approval, nor support of its products or 
                services, and you are strictly prohibited from:
              </p>
              <ul>
                <li>framing or creating a browser or border environment, nor mirror, any part of the content, Site, or Services;</li>
                <li>replicating Our Content;</li>
                <li>falsifying or misrepresenting any information about our products or Services;</li>
                <li>incorporating the Site or Services into other links;</li>
                <li>using No Cap Vote's or No Cap Vote Entities' copyright or trademarks;</li>
                <li>expressly implying our endorsement, sponsorship, and the like, of any products or services;</li>
                <li>directly linking, downloading, or using images on the Site or Services to be displayed on another site for 
                any reason;</li>
                <li>linking images from another site to our Site or Services to the extent that the image is obscured or 
                framed by any third-party content or materials;</li>
                <li>tricking or defrauding any user(s), person(s), or entity(ies) for any purpose; or</li>
                <li>in our opinion, containing any offensive, distasteful, vulgar, or controversial content.</li>
              </ul>
              <p>
                We are not responsible nor liable for any links for/to other sites and are not supported, approved, endorsed, 
                or controlled by us, and you acknowledge, accept, and agree to hold us harmless from any and all liability 
                for any losses or damage caused by third parties to you.
              </p>
              <p>
                At your own risk and responsibility, subject to the Terms and Applicable Laws, any link(s) that you Submit or 
                Transmit through the Services will be deemed your acknowledgement, acceptance, and agreement that you have all 
                Authorities to control, place, and/or enable such link(s).
              </p>
            </section>

            {/* Section 14 */}
            <section id="section-14" className="terms-section">
              <h2>14. Third-Party Access</h2>
              <p>
                Our <a href="/privacypolicy">Privacy Policy</a> explains the importance of how we collect, store, use, 
                process, share, sell, disclose, and protect user-generated content and information that you, or other users, 
                choose to provide to us.
              </p>
              <p>
                Access or using the Site or Services through other third-party services or providers, distributors, App 
                providers, or linking Your No Cap Vote Account to an account you hold with another service may provide us 
                access and login information to your third-party account. You may, at your own risk, through third-party 
                services, register or log on to access our Site or use our Services. However, you must also adhere to that 
                third-party's terms, conditions, and policies when you use the third-party(ies') products or services and/or 
                when you use or access communications you receive from third parties while accessing the Services. Our Term 
                and policies apply only to us, independent of the other service provider(s) that your other account is linked 
                to, which you must also adhere to.
              </p>
              <p className="subsection-title"><strong>Google Play or App Store Terms.</strong></p>
              <p>
                No Cap Vote is responsible for the No Cap Vote App, its maintenance, Services, if you access or download the 
                No Cap Vote App through Third-Party App providers, such as Google Play or App Store ("App Distributor"). No 
                Cap Vote grants you the limited, nontransferable license to use the No Cap Vote App from your device(s) when 
                you access or download No Cap Vote's App through App Store or Google Play. The third-party App Distributor:
              </p>
              <ul>
                <li>has no obligation or responsibility to respond to any Claims you or any third-party may have pertaining 
                to the No Cap Vote App;</li>
                <li>has no obligation or responsibility in maintaining or supporting the No Cap Vote App;</li>
                <li>makes no representations nor warranties on behalf of the No Cap Vote App and may enforce the Terms; and</li>
                <li>subject to the required Applicable Laws, will have no other warranty obligation relating to the No Cap 
                Vote App and may have the right to enforce the Terms against you as third-party beneficiaries of the Terms.</li>
              </ul>
              <p>
                Although No Cap Vote is responsible for administering any claims or losses should there be any failure of the 
                No Cap Vote App to conform to any warranty, you may also contact the applicable third-party App Distributor. 
                Subject to Applicable Laws, No Cap Vote shall address any third-party infringement claims upon a third party's 
                intellectual property rights. Further, although you may be using the No Cap Vote App, you must also adhere to 
                third-party App Distributor's terms or policies.
              </p>
            </section>

            {/* Section 15 */}
            <section id="section-15" className="terms-section">
              <h2>15. Third-Party Providers</h2>
              <p>
                Subject to the Terms and policies, we may have, or may send, you links to other content and materials, 
                including, but not limited to, other user content, known or unknown, outside of the Site or Services, your 
                User Content, products, services, advertisements, promotions, applications, software, tools, and/or 
                information from other sources, ("Third-Party Content"), provided by affiliates, partners, advertisers, 
                service providers, and other users, and/or may be derived from other third parties, for any purpose, 
                ("Third-Party Providers"). You may have, or will sign up and create, a third-party account, ("Third-Party 
                Account"), with Third-Party Providers.
              </p>
              <p>
                While accessing or using the Site or Services, we may use Third-Party Content that you access or use, 
                including, but not limited to, links, materials, features, and functionalities that power AI query features, 
                posts, transmissions, content, chat services, data, predictions, responses, search, and like services, 
                ("Third-Party Functions").
              </p>
              <p>
                By engaging with, engaging outside of, or access or using, the Services, your access with, use of, conduct 
                with any Third-Party Content, Third-Party Providers, Third-Party Functions, including, but not limited to, 
                transactions, purchases, communications, promotions, other engagements, as well as external links or websites 
                or mobile applications accessed from the Site or Services, or otherwise:
              </p>
              <ul className="letter-list">
                <li>(a) is solely at your own risk;</li>
                <li>(b) is solely your obligation and responsibility to pay any and/or all fees due, charges, or usage 
                limitations associated to, and incurred by, you;</li>
                <li>(c) you have the Authority to grant us access to your Third-Party Account, including, but not limited to, 
                other content, information, or contact lists;</li>
                <li>(d) you are subject to, and regulated, by their own terms of service and policies;</li>
                <li>(e) may lead to unfair, unreliable, or bias data and/or predictions;</li>
                <li>(f) any and/or all content or materials you share, copy, link, or store with other Third-Party Providers 
                who then use, access, share, or store these contents or materials to others are solely your responsibility;</li>
                <li>(g) is the responsibility of other third parties, entities, and/or individuals;</li>
                <li>(h) is solely your responsibility to contact us at notice@nocapvote.com if you disable the connection 
                between the Services and your Third-Party Account;</li>
                <li>(i) is not our responsibility or liability, and are not supported, approved, endorsed, or controlled by us, 
                and that you acknowledge, accept, and agree to hold us harmless from any and all liability for any losses or 
                damage caused by third parties to you;</li>
                <li>(j) is not supervised, reviewed, surveilled, investigated, or edited by us to check for accuracies, 
                reliability, completeness, legalities, nor improprieties; or</li>
                <li>(k) is not, in any way, our representation, views, or warranty relating to Third-Party Providers, 
                Third-Party Content, Third-Party Functions, conduct, or otherwise.</li>
              </ul>
            </section>

            {/* Section 16 */}
            <section id="section-16" className="terms-section">
              <h2>16. Advertisements</h2>
              <p>
                While accessing or using the Site or Services, you may be exposed to advertising content pertaining to 
                products or services that we may also offer as part of the Services.
              </p>
              <p>
                Additionally, advertisers represent and warrant that they have all the Authority, and are solely responsible 
                and liable, for any and all advertisements, products, services, or other content they may place in certain 
                areas of the Site or Services. Subject to the Digital Millenium Copyright Act Notice and Policy Takedown 
                processes, advertisers acknowledge, accept, and agree that no refunds nor compensation are granted; that No 
                Cap Vote or No Cap Vote Entities are not responsible nor liable whatsoever to any of the advertisers' 
                advertisement, content, products, services, and/or actions.
              </p>
            </section>

            {/* Section 17 */}
            <section id="section-17" className="terms-section">
              <h2>17. Miscellaneous Fees</h2>
              <p>
                The Services may offer available services, features, and functionalities to you through your mobile device. 
                Accessing or using the Site or Service through your mobile device may necessitate downloading applications, 
                uploading content, and/or accessing messages. You are solely responsible for any standard messaging, data, or 
                any other fees, known or unknown, charged by your mobile carrier ("mobile fees"). No Cap Vote or No Cap Vote 
                Entities are not responsible or liable for any of your mobile carrier fees. In the event that we may charge 
                any mobile fees to you, we will communicate with you via your mobile device relating to No Cap Vote and 
                disclose the charges to you prior to completing any registration.
              </p>
            </section>

            {/* Section 18 */}
            <section id="section-18" className="terms-section">
              <h2>18. Promotions</h2>
              <p>
                You may promote, conduct, or administer contests, competitions, sponsorships, awards, events, panels, 
                ("Promotions"), as a promoter, through our Services. Subject to your compliance with terms and policies, 
                Applicable Laws, and/or U.S. Federal Trade Commission Guidelines, ("Ad Guidelines"), regardless of whether 
                you permitted the access or use of the Services through Your Account, unless you possess our expressed written 
                permission, at your own risk:
              </p>
              <ul>
                <li>you are solely responsible for any and/or all facets of the operations of your Promotions, including, but 
                not limited to, notices, posts, discussions, content, performance, expenses, rules, regulations, limitations, 
                eligibility, obligations, restrictions, filings, licenses, insurances, fees, bonds, regulatory approval, 
                safety, security, accounting, taxes, transactions, and related functions, and, specifically, the 
                acknowledgment and agreement from all participants of your Promotions of our release from any and/or all 
                liability;</li>
                <li>you are solely responsible for all transactions, participation, activities, product, products, or service 
                swapping, content disclosures, and the like, with any third parties that you may find, or interact with, 
                through the Services;</li>
                <li>your Promotions are not our responsibility or liability, and we do not, and will not, support, approve, 
                endorse, or control, and that you acknowledge, accept, and agree to release and hold us harmless from any and 
                all liability for any losses or damage caused by you and/or third parties to you;</li>
                <li>you, or your Promotions, will not, and are restricted to, describe us, in any way, shape, or form as 
                sponsors, co-sponsors, endorsers, administrators, associates, or supporters of your Promotions; and</li>
                <li>should your Promotions violate any of our Terms and policies, or the rights of any third party, we have 
                all rights to delete or cancel your Promotions at any time.</li>
              </ul>
              <p>
                By conducting any Promotions on the Site or through the Services, you represent and warrant that you have all 
                the Authority, rights, permissions, or clearances to waive: (i) any approval or inspection of any marketing 
                or promotional materials, or (ii) any and all rights of privacy, publicity, morality, and any other rights.
              </p>
            </section>

            {/* Section 19 */}
            <section id="section-19" className="terms-section">
              <h2>19. Products and Services</h2>
              <p>
                Subject to Applicable Laws and your compliance with the Terms, in any action within the Site or Services, for 
                marketing, promotional, and/or distribution purposes, at any time, for any reason:
              </p>
              <ul>
                <li>we reserve the right to accept, refuse, decline, cancel, or classify any products or services;</li>
                <li>any products or services submitted or transmitted may be subject to approval;</li>
                <li>we reserve, and have, the exclusive right to monetize products or services, including, but not limited to, 
                the right to sell, resell, promote, conduct, administer, display, and/or market products, services, including, 
                but not limited to, promotions, contests, competitions, sponsorships, awards, and the like;</li>
                <li>you represent that you have all the Authority to Submit or Transmit any content, materials, products, or 
                services through the Services and that you grant us all The Permissions, under copyright law or otherwise, to 
                use, disseminate, monetize, place, and/or distribute, in any manner, mode of delivery, position, form, format, 
                or medium as described herein;</li>
                <li>nothing constitutes a binding offer to distribute, sell, donate, or offer any products or services; and/or</li>
                <li>rates for purchases and specifications may be subject to change.</li>
              </ul>
            </section>

            {/* Section 20 */}
            <section id="section-20" className="terms-section">
              <h2>20. Warranties and Disclaimers</h2>
              <p className="uppercase-text">
                YOU EXPRESSLY AGREE THAT YOUR access or use of the Site or Services IS AT YOUR OWN RISK. YOU ACKNOWLEDGE THAT 
                THE SERVICES AND ALL CONTENT CONTAINED WITHIN THE SERVICES, INCLUDING, BUT NOT LIMITED TO, MATERIALS, CONTENT, 
                THIRD-PARTY linkS to other sites, PRODUCTS, SERVICES, DOWNLOADED SOFTWARE, OR ADVERTISEMENTS ARE PROVIDED ON AN 
                "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE SERVICES, 
                INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OR TERMS OF MERCHANTABILITY OR USE AND FITNESS FOR A 
                PARTICULAR PURPOSE, WARRANTIES OF TITLE, WARRANTIES AGAINST INFRINGEMENT, OR THOSE ARISING BY STATUTE OR 
                OTHERWISE IN LAW FROM A COURSE OF DEALING OR USAGE OF TRADE.
              </p>
              <p className="uppercase-text">
                NO CAP VOTE, NOR its affiliates, subsidiary(ies), partner(s), associates, or related entities, or respective 
                officers, directors, shareholders, members, employees, representatives, agents, contractors, third-party 
                service providers, vendors, suppliers, or licensors, as applicable, ("NO CAP VOTE PARTIES"), in connection 
                with these terms or your access or use of the Site or Services, DO NOT MAKE ANY WARRANTIES, PROMISES, OR 
                representations of any kinD, EXPRESSED OR IMPLIED, reLATING TO the site, SERVICES, user content, MATERIALS or 
                other content, advertising content, information, THIRD-PARTY linkS to/From sites OR RESOURCES, PRODUCTS, or 
                services available on or through, and/or the results that may or may not be obtained from use of the content 
                of, the Site or Services.
              </p>
              <p className="uppercase-text">
                NO CAP VOTE DOES NOT, NOR DO NO CAP VOTE PARTIES, make any WARRANTIES, PROMISES, OR representations of any kind:
              </p>
              <ul className="uppercase-text">
                <li>THAT THE AVAILABILITY, FEATURES, OR FUNCTIONS OF THE SITE OR SERVICES WILL BE UNINTERRUPTED, CONTINUOUS, 
                ACCESSIBLE, SECURE, TIMELY, OR ERROR-FREE;</li>
                <li>OF ANY ACCURACIES, RELIABILITY, AVAILABILITY, COMPLETENESS, ACCEPTABILITY, TRUTHFULNESS, LEGALITIES, 
                IMPROPRIETIES, SECURITY, APPROPRIATENESS FOR CHILDREN, OR TIMELINESS OF ANY INFORMATION, MATERIALS, CONTENT, 
                PRODUCTS, SERVICES, OR DATA SUBMITTED, TRANSMITTED, STORED, AND/OR CONTAINED WITHIN, OR THROUGHOUT THE SITE 
                OR SERVICES FROM USER CONTENT, THIRD PARTIES, OR OTHERWISE;</li>
                <li>THAT THE ABILITY TO AUTOMATICALLY DOWNLOAD AND/OR INSTALL UPDATES AND THE LIKE WILL BE AVAILABLE;</li>
                <li>THAT ISSUES, DELETIONS, DEFECTS, OR FAILURES IN SUBMITTING, TRANSMITTING, STORING, OR USABILITY WILL BE 
                CORRECTED;</li>
                <li>THAT THIS SITE, SERVICES, OR THE SERVERS ARE SECURE, FREE OF VIRUSES, MALWARE, ALTERING IDENTIFIERS, 
                SPYWARE, OR OTHER UNAUTHORIZED, HARMFUL, OR DAMAGING SOFTWARE, APPLICATIONS, OR COMPONENTS;</li>
                <li>THAT THE SERVICES OR SERVERS DO NOT VIOLATE ANY PATENT OR OTHER INTELLECTUAL PROPERTY RIGHTS OF ANY 
                PERSON, BUSINESS, OR ENTITY;</li>
                <li>THAT THE SITE OR SERVICES WILL BE AVAILABLE, WILL MAINTAIN THE PROPER SUPPORT OR FUNCTIONING OF THE SITE 
                OR SERVICES, OR WILL MEET YOUR REQUIREMENTS;</li>
                <li>OF any CONTENT, INFORMATION, PRODUCTS, SERVICES, MATERIALS, USER CONTENT, ACTIVITY, POSTS, downloads, 
                third-party links to/FROM sites OR RESOURCES, OR TRANSACTIONS shared with, sold to, sold/purchased by, OR 
                provided by ANY THIRD PARTY, USERs, ADVERTISERS, PROMOTERS, SPONSORS, ORGANIZATIONS, oR OTHER ENTITIES OR 
                THIRD PARTIES accessing or using the Site or Services;</li>
                <li>RELATING TO TAX OR INVESTMENT ADVICE OR ADVOCATE THE PURCHASE OR SALE OF ANY SECURITY OR INVESTMENT;</li>
                <li>OF ANY HARM TO YOUR DEVICES, SUCH AS COMPUTER, MOBILE, TABLET, OR OTHER PROPERTY THAT MAY CAUSE 
                TECHNOLOGICAL FAILURE, MALFUNCTION, DATA LOSS, OR OTHER HARM. YOU EXPRESSLY AGREE THAT YOU SOLELY ASSUME THE 
                ENTIRE COST OF ALL NECESSARY SERVICING, REPAIR, OR CORRECTION; AND</li>
                <li>FOR ANY WRONGFUL, UNLAWFUL, OR HARMFUL ACTIONS OR DAMAGE CAUSED BY THIRD PARTIES, USERS, OR AN ACT OF GOD.</li>
              </ul>
            </section>

            {/* Section 21 */}
            <section id="section-21" className="terms-section">
              <h2>21. Limitation of Liability</h2>
              <p className="uppercase-text">
                To the maximum extent permissible by applicable law, in connection with these terms or your access or use of 
                the Site or Services, notwithstanding anything to the contrary, IN NO EVENT SHALL NO CAP VOTE, NOR NO CAP VOTE 
                PARTIES, be liable nor responsible for any direct, indirect, special, incidential, EXEMPLARY OR punitive 
                DAMAGES, consequential damages (including loss of goodwill, lost profits or revenues, whether incurred 
                directly or indirectly, lost transmissions or data, LOST OPPORTUNITIES, or other intangible losses or damages), 
                TREBEL, WORK STOPPAGE, alleged losses, INCLUDING, BUT NOT LIMITED TO, personal OR BODILY damage, EMOTIONAL 
                DISTRESS, the cost of substitute service, devaluation of your information, or other MUltiple damages of any 
                kind, WHETHER SUCH ALLEGATIONS ARE FOR TORTS, NEGLIGENCE, BREACH OF CONTRACT, OR OTHERWISE, even if we have OR 
                HAVE NOT been AWARE OR advised of the possibility of such damages OR LOSSES, ARISING FROM, IN CONNECTION WITH, 
                OR RESULTING FROM:
              </p>
              <ul className="uppercase-text">
                <li>ANY CONDUCT, actions, and/or inactions of any user or third party;</li>
                <li>any CONTENT, INFORMATION, SERVICES, PRODUCTS, MATERIALS, USER CONTENT, ACTIVITY, POSTS, downloads, 
                third-party links to/FOR sites OR RESOURCES, OR TRANSACTIONS shared with, sold to, sold/purchased by, OR 
                provided by ANY THIRD PARTY, USERs, ADVERTISERS, PROMOTERS, SPONSORS, ORGANIZATIONS, oR OTHER ENTITIES OR 
                THIRD PARTIES accessing or using the Site or Services;</li>
                <li>YOUR USE OF, loss of USE, limitation, and/or suspension or termination to THE SERVICES, INCLUDING, but not 
                limited to, YOUR ACCOUNT;</li>
                <li>ANY AMENDMENTS, MODIFICATIONS, DELETIONS, REMOVALS, OR SUSPENSIONS OF ALL OR PART OF ANY CONTENT, SITE, OR 
                SERVICES;</li>
                <li>the content RELATING TO any errorS, omissions, DEFECTS, mistakes, MALFUNCTIONS, FAILURES IN USE, 
                PERFORMANCE, SUPPORT, STORING, TECHNICAL OR OTHERWISE, in ANY content, SITE, OR SERVICES;</li>
                <li>YOUR RELIABILITY ON THE AVAILABILITY, COMPLETENESS, ACCEPTABILITY, TRUTHFULNESS, LEGALITIES, IMPROPRIETIES, 
                SECURITY, APPROPRIATENESS FOR CHILDREN, OR TIMELINESS OF ANY VIEWS, OPINIONS, RECOMMENDATIONS, FACTS, 
                STATEMENTS, INFORMATION OR CONTENT SUBMITTED, TRANSMITTED, STORED, AND CONTAINED WITHIN THE SERVICES OF ANY 
                INFORMATION, CONTENT, PRODUCTS, SERVICES, OR DATA PROVIDED THROUGHOUT THE SITE OR SERVICES FROM USER CONTENT, 
                ADVERTISERS, PROMOTERS, SPONSORS, ORGANIZATIONS, OR ANY OTHER ENTITIES OR THIRD PARTIES;</li>
                <li>any conduct, content of any user or third party on the services, including, but not limited to, DEFAMATORY, 
                OFFENSIVE, OR ILLEGAL CONTACT OF OTHER USERS OR THIRD PARTY;</li>
                <li>ANY UNAUTHORIZED ACCESS to, use OF, alteration to, RECORDING OF, AND/OR security breach of YOUr DATA, YOUR 
                ACCOUNT, CONTENT, OR TRANSMISSIONS;</li>
                <li>VIRUSES, MALWARE, ALTERING IDENTIFIERS, SPYWARE, OR OTHER UNAUTHORIZED OR HARMFUL OR DAMAGING SOFTWARE OR 
                COMPONENTS;</li>
                <li>ANY HARM, THEFT, OR DESTRUCTION TO YOUR DEVICES, SUCH AS COMPUTER, MOBILE, TABLET, AND/OR OTHER PROPERTY 
                THAT MAY CAUSE TECHNOLOGICAL FAILURE OR MALFUNCTION, DATA LOSS, OR OTHER HARM;</li>
                <li>DATA CHARGES, SMS/TEXT-MESSAGING CHARGES, OR ANY OTHER THIRD-PARTY CHARGES FROM THIRD-PARTIES UNAFFILIATED 
                TO US;</li>
                <li>ANY DIRECT DAMAGES, OR IN THE AGGREGATE, SHALL NOT EXCEED FIFTY DOLLARS ($50) OR THE AMOUNT PAID TO US, 
                WHICHEVER IS LESSER OF THE AMOUNT, IN THE TWO MONTHS PAST BASED ON ANY CAUSE(S) OF ACTION ARISING FROM, OR IN 
                CONNECTION TO, YOUR access or use of the Site or Services. PLEASE CHECK YOUR STATE LAWS WHERE YOU RESIDE 
                RELATING TO LIMITATIONS OF LIABILITY ON WARRANTIES OR DAMAGES; AND</li>
                <li>ANY WRONGFUL, UNLAWFUL, OR HARMFUL ACTIONS OR DAMAGE CAUSED BY THIRD PARTIES, USERS, OR AN ACT OF GOD.</li>
              </ul>
              <p className="uppercase-text">
                Unless you possess our expressed written permission, NO CAP VOTE, nor NO CAP VOTE parties, do not, and will 
                not, WARRANT, REPRESENT, endorse, support, approve, sponsor, co-sponsor, or control any user content, 
                third-party content, or any other content. NO CAP VOTE AND NO CAP VOTE parties disclaim any and/or all 
                expressed or implied promises or warranties relating to the site or services.
              </p>
              <p className="uppercase-text">
                ACCESSING THE SITE OR USING THE SERVICES IS AT YOUR OWN RISK. IF YOU ARE NOT SATISIFIED WITH ANY OF OUR 
                pOLICIES, DISCLAIMER, LIMITATIONS OF LIABILITY, CONTENT, OR MATERIALS IN THE SITE OR SERVICES, YOU MAY NOT 
                access or use the Site or Services.
              </p>
            </section>

            {/* Section 22 */}
            <section id="section-22" className="terms-section">
              <h2>22. Class-Action Waiver</h2>
              <p>
                You acknowledge, accept, and agree that any demands, claims, cause of action, disputes, damages, obligations, 
                losses, liabilities, judgments, expenses (including, but not limited to, litigation costs, accounting, and 
                attorneys' fees), due to, arising FROM, or related to the Terms or Our Policies, NO CAP VOTE, and/or NO CAP 
                VOTE Entities, you unconditionally consent to, and agree that, any claim(s), dispute(s), or controversy(ies) 
                must only be resolved by binding and final arbitration on an individual basis; and you may not bring any 
                claim(s) as a plaintiff, representative action, class proceeding, nor as a class member, collective, or 
                consolidation, limiting the remedies available in the event of a dispute. In addition, you waive any and/or 
                all your rights to participate in any court or jury trial, class-action lawsuit, class wide arbitration, 
                collective action, private attorney actions, and consolidation with other arbitrations against us.
              </p>
            </section>

            {/* Section 23 */}
            <section id="section-23" className="terms-section">
              <h2>23. Informal Dispute Resolution</h2>
              <p>
                No Cap Vote believes that good-faith efforts to resolve any Disputes before any arbitration are mutually 
                beneficial to all parties involved.
              </p>
              <p>
                You acknowledge, accept, and agree that, before any arbitration procedures begin, any Disputes will, initially, 
                be resolved through an informal, telephonic meet and confer or by email between you, and your representative 
                (if any), and No Cap Vote to discuss the Dispute(s) to reach an informal resolution.
              </p>
              <p>
                The party initiating the informal dispute resolution must send a meet and confer notice, ("Notice"), arising 
                from any Disputes, must give Notice to the other party in writing at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>, which shall occur within 60 days, or on an 
                agreed upon period of time, after the Notice is received by the other party. The Notice must include your name, 
                and your representative (if any), contact information, such as email, phone number, (and representative 
                information, if any), a summary description of the nature of the dispute, the specific relief sought, including 
                the calculation of damages sought, and your attestation that the summary description is under penalty of 
                perjury. Any Notice to you will be sent to your email address associated with Your Account. From the time of 
                the initial Notice and before arbitration procedures may begin, if at all, the parties may continue to attempt 
                to resolve any Disputes provided to No Cap Vote. The parties agree that any applicable limitations period or 
                filing fees or deadlines will be tolled while the parties engage in an informal dispute resolution. This 
                section does not apply to Disputes relating to intellectual property.
              </p>
            </section>

            {/* Section 24 */}
            <section id="section-24" className="terms-section">
              <h2>24. Arbitration Agreement</h2>
              <p>
                If you are not satisfied with the attempt to initially resolve the dispute informally as described above, 
                regardless of what forum the initiating party chose, unless you possess our expressed written consent in 
                writing, you and No Cap Vote acknowledge, accept, agree, and consent that:
              </p>
              <ul>
                <li>you and No Cap Vote agree to resolve any legal dispute in accordance with the laws of the State of 
                California and applicable United States laws;</li>
                <li>to the maximum extent allowed by law, except as set forth in the Informal Dispute Resolution, any dispute, 
                claim, controversy, or cause of action arising out of, relating to, or connected, in any way, with No Cap 
                Vote's Terms, access or use of the Site or Services, or content will be resolved by final and binding 
                arbitration administered by the American Arbitration Association, ("AAA"), in an individual capacity only, and 
                not the courts of general jurisdiction nor may you bring any claim(s) as a plaintiff, representative action, 
                class proceeding, nor as a class member, collective, or consolidation, limiting the remedies available in the 
                event of a dispute. The AAA rules are available online at www.adr.org; and</li>
                <li>you waive any and/or all your rights to participate in any court or jury trial, class-action lawsuit, 
                class-wide arbitration, collective action, private attorney actions, and consolidation with other arbitrations 
                against us, ("Agreement").</li>
              </ul>
              <p>
                Exceptions to this Arbitration Agreement are that you and No Cap Vote: (i) retain the right to sue in small 
                claims court, (ii) may bring suit in court to determine the enforceability of the informal dispute resolution 
                process, and/or (iii) may bring suit in court against each other to seek declaratory or injunctive relief to 
                enjoin the infringement or other misuse of intellectual property rights.
              </p>
            </section>

            {/* Section 25 */}
            <section id="section-25" className="terms-section">
              <h2>25. Termination of Access</h2>
              <p>Until terminated by you or us, the Terms of Service are in effect.</p>
              <p>
                We reserve the right, at any time, for any reason, to restrict, terminate, suspend, and/or delete, in whole or 
                in part, your access and/or use of the Services, your password or Your Account, without noticing you, if we 
                believe that you breached or violated the Terms set forth herein, including, but not limited to, possible 
                legal liability or dormant account(s). Any violation of these Terms may be referred to law enforcement 
                authorities. Subject to your access or use of the Services, you will continue to be bound by the Terms in 
                effect as of the date of Your Account restriction, termination, suspension, and/or deletion, which will not 
                limit our rights or remedies at law or in equity.
              </p>
            </section>

            {/* Section 26 */}
            <section id="section-26" className="terms-section">
              <h2>26. Notices and Changes to Terms and Services</h2>
              <p>
                At any time, for any reason, No Cap Vote may revise provisions of the Terms of Service, use, and other 
                functionalities or features to comply with Applicable Laws, regulations, including, but not limited to, 
                improvements, modifications, or upgrades. You acknowledge, accept, and agree that No Cap Vote and you will 
                electronically communicate. No Cap Vote will use reasonable efforts to electronically provide, transmit, email, 
                text message or SMS, MMS, post, push notification, postal mail, or notify you with known, or to be formed, 
                disclosures, notices, announcements, transaction information, or other communications that you deemed to have 
                received, which satisfies any legal requirements. If you continue to access or use the Site or Services after 
                the notice is posted, you will be deemed to have acknowledged and agreed to be legally bound that the latter 
                agreement of our Terms, policies, and/or Services shall prevail. If you do not agree to be bound by these 
                Terms or our policies, you may not access or use the Site or Services.
              </p>
            </section>

            {/* Section 27 */}
            <section id="section-27" className="terms-section">
              <h2>27. Governing Law and Forum Choice</h2>
              <p>
                Any Disputes arising out of, or in connection with the Site or Services, Terms, and/or content shall be 
                governed by, and construed, in accordance with the laws of the State of California, without giving effect to 
                conflicts-of-law provisions, except to the extent that law is inconsistent with or preempted by federal law. 
                You and No Cap Vote unconditionally and irrevocably consent and agree to: (i) waive any objection to 
                jurisdiction and venue in federal or state courts; (ii) submit to the appropriate state or federal court 
                located in Los Angeles County, California, (iii) any Disputes or cause of action arising out of, or in 
                connection with the Site or Services, Terms, and/or content must be filed within one (1) year after such claim 
                or cause of action arose or be forever barred, and (iv) agree to service of process by email.
              </p>
            </section>

            {/* Section 28 */}
            <section id="section-28" className="terms-section">
              <h2>28. California Residents</h2>
              <p>
                If you are a California resident, you hereby waive California Civil Code § 1542, and/or any similar provision 
                in another jurisdiction, which states: "A general release does not extend to claims that the creditor or 
                releasing party does not know or suspect to exist in his or her favor at the time of executing the release and 
                that, if known by him or her, would have materially affected his or her settlement with the debtor or released 
                party."
              </p>
              <p>
                If you are not a California resident, under any statute or common law principles similar to California Civil 
                Code § 1542, you waive your rights that governs your rights in the jurisdiction where you reside.
              </p>
            </section>

            {/* Section 29 */}
            <section id="section-29" className="terms-section">
              <h2>29. Survivability</h2>
              <p>
                The provisions of the Terms shall survive the termination of Your Account, access or use of the Site or 
                Services provided, and this agreement. In the event of the termination of the Terms, for any reason, you 
                acknowledge, accept, and agree to that provisions relating to The Permissions, Disputes, Warranties and 
                Disclaimers, Limitation of Liability, your access or use of the Site or Services, and other provisions will 
                survive where equitable and appropriate.
              </p>
            </section>

            {/* Section 30 */}
            <section id="section-30" className="terms-section">
              <h2>30. Miscellaneous</h2>
              <p>
                To affect any waiver of any provision of our Terms or policies, Authorization must be written and signed by an 
                authorized No Cap Vote representative. Our failure to enforce or insist upon performance of any provision of 
                this agreement shall not be construed as a waiver of any provision or right. The course of dealing between the 
                parties or usage of trade shall not act to modify any provision of the agreement. At any time, for any reason, 
                without notice to you, we may assign our rights and duties under this agreement to any party. We reserve our 
                rights to enforce these rights and provisions now or in the future.
              </p>
            </section>

            {/* Section 31 */}
            <section id="section-31" className="terms-section">
              <h2>31. Entire Agreement</h2>
              <p>
                The Terms and Our Policies constitute the entire agreement between us and you with respect to the subject 
                matters contained in these Terms and supersedes all prior and contemporaneous notices, agreements, and 
                communications, written or oral, between you and No Cap Vote or No Cap Vote Entities regarding your use of the 
                Services. Without our expressed written authorization, the Terms may not be amended, altered, nor waived. The 
                Terms are not for the benefit of, and do not create, any third-party beneficiaries. You acknowledge and agree 
                that you do not have any Authority to bind No Cap Vote or No Cap Vote Entities in any manner, nor are you a 
                partner, agent, employee or joint venture of No Cap Vote.
              </p>
              <p>
                We reserve the right, without noticing you, at any time, to revise, amend, add, modify, improve, change, 
                supplement, restrict, discontinue, and/or suspend, in whole or in part, any access, use, availability, feature, 
                functionality, products, services, descriptions, errors, omissions, and/or support of the Site or Services.
              </p>
            </section>

            {/* Section 32 */}
            <section id="section-32" className="terms-section">
              <h2>32. Assignment</h2>
              <p>
                The Terms and policies are binding upon and shall inure to the benefit of the parties, each of our affiliates, 
                subsidiary(ies), partner(s), associates, or related entities, or their respective officers, directors, 
                shareholders, members, employees, representatives, agents, contractors, third-party service providers, vendors, 
                suppliers, or licensors. Unless you possess our expressed written permission, under the Terms, you may not, and 
                will not, transfer or assign any of your rights or obligations to anyone. Without our written consent, any 
                assignment shall be void and invalid.
              </p>
            </section>

            {/* Section 33 */}
            <section id="section-33" className="terms-section">
              <h2>33. Severability</h2>
              <p>
                If any provision of the Terms is found invalid, void, or unenforceable, such provision shall be fully 
                severable, and shall not affect the validity and enforceability of any remaining provisions of the Terms.
              </p>
            </section>

            {/* Section 34 */}
            <section id="section-34" className="terms-section">
              <h2>34. Contact Information</h2>
              <p>
                If you have any questions, or need further assistance, please contact No Cap Vote at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
            </section>
          </div>
        </div>
        <BackTop />
      </div>
    );
  }
}

export default TermsOfService;